import { Route } from 'react-router-dom'

import AboutUs from '@/pages/aboutus'
import Home from '@/pages/home'
import Category from '@/pages/category'
import Search from '@/pages/search'
import TermsAndConditions from '@/pages/terms-conditions'
import SubCategory from '@/pages/subcategory'
import Product from '@/pages/product'
import Login from '@/pages/login'
import Register from '@/pages/register'
import Promos from '@/pages/promos'
import ShoppingCart from '@/pages/shopping-cart'
import CustomersEntity from '@/entities/api/customers/customer'
import Payment from '@/pages/payment'
import Account from '@/pages/account'

const ShopRoutesModel = (
	customer: CustomersEntity | null,
	token: string | null
) => (
	<>
		<Route
			path='/Nosotros'
			element={<AboutUs customer={customer} token={token} />}
		/>
		<Route
			path='/Categoria/:type'
			element={<Category customer={customer} token={token} />}
		/>
		<Route
			path='/Buscar'
			element={<Search customer={customer} token={token} />}
		/>
		<Route
			path='/Terminos'
			element={<TermsAndConditions customer={customer} token={token} />}
		/>
		<Route
			path='/SubCategoria/:type/:category'
			element={<SubCategory customer={customer} token={token} />}
		/>
		<Route
			path='/Producto/:product/:id'
			element={<Product customer={customer} token={token} />}
		/>
		<Route path='/Login' element={<Login />} />
		<Route path='/Registro' element={<Register />} />
		<Route
			path='/Promociones'
			element={<Promos customer={customer} token={token} />}
		/>
		<Route
			path='/Carrito'
			element={<ShoppingCart customer={customer} token={token} />}
		/>

		<Route
			path='/Perfil/:zone'
			element={<Account customer={customer} token={token} />}
		/>
		<Route
			path='/Pago'
			element={<Payment customer={customer} token={token} />}
		/>

		<Route path='/' element={<Home customer={customer} token={token} />} />
	</>
)

export default ShopRoutesModel
